export enum MachineDiagnostic {
  NoDataUploaded = "NoDataUploaded",
  NoQuestResponsesReceived = "NoQuestResponsesReceived",
}
